module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "not-found"
  }, [_c('h1', [_vm._v("404")]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t('web.not_found.card_header')))]), _vm._v(" "), _c('div', {
    staticClass: "links"
  }, [(!_vm.loggedIn && _vm.validSite) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'Login'
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('web.not_found.login_link')) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.loggedIn && _vm.validSite) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'Dashboard'
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('web.not_found.dashboard_link')) + "\n    ")]) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c284342"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/NotFound.vue
// module id = 519
// module chunks = 1